import { useNavigate } from "react-router-dom";
import KitchenStaffAuthGate from "@/components/mobile/KitchenStaffAuthGate";
import { enterStaffPortal, applyStaffPortalDocument } from "@/lib/staffPortal";

export default function KitchenStaffJoin() {
  const navigate = useNavigate();

  const onComplete = () => {
    enterStaffPortal("kitchen", window.location.origin + "/pp/hub");
    applyStaffPortalDocument("kitchen");
    navigate("/pp/hub", { replace: true });
  };

  return <KitchenStaffAuthGate initialMode="signup" onComplete={onComplete} />;
}
